import { createBrowserRouter } from "react-router-dom";
import FlashReport from "../Pages/FlashReport/FlashReport";
import Scheduler from "../Pages/Schedulers/Scheduler";
import { setToken } from "../API/tokenStore";

import { getDataToShowPDF, v2Clients } from "../API/backend";
import { getPrivileges, exchangeToken, getUserPreferences } from "../API/nimbleAPI";

/**
 *
 * @param {Request} request
 * @returns
 */
async function loader(request) {


  const url = new URL(request.url);
  const clientName = url.searchParams.get("clientName");
  const toBeChangeToURLV2 = await v2Clients();
  const isV2 = toBeChangeToURLV2.includes(clientName);
  const clientNameUrlVersion = isV2 ? "v2" : "v1";

  const menuID = url.searchParams.get("menuID");
  const authID = url.searchParams.get("authID");
  const UID = url.searchParams.get("UID");
  const clientID = url.searchParams.get("clientID");
  const corpId = url.searchParams.get("corpId");

  if (!authID || !menuID || !UID || !clientName || !clientID || !corpId) {
    throw new Response("Missing required parameters", { status: 400 });
  }
  const { token, minutesToExpire, refAuth } = await exchangeToken(clientNameUrlVersion, authID);
  setToken(token, minutesToExpire, refAuth, clientNameUrlVersion ,isV2);
  const privileges = await getPrivileges(UID, menuID);
  const userPreferences = await getUserPreferences(UID);

  return { privileges, token, clientID, clientName, UID, corpId, userPreferences };
}

const router = createBrowserRouter([
  {
    loader: ({ request }) => loader(request),
    path: "/scheduler",
    element: <Scheduler />,
  },
  {
    loader: ({ request }) => loader(request),
    path: "/flashreport",
    element: <FlashReport />,
  },
  {
    loader: async ({ request }) => {
      const url = new URL(request.url);
      const id = url.searchParams.get("id");

      let pdfData = await getDataToShowPDF(id)

      return { pdfData, showCustomScreen: false }
    },
    path: "/generatepdf",
    element: <FlashReport />,
  },
]);

export default router;
